// o helper ErrorsPapelSegurancaHelper
// engloba tratativas geral do papel de seguranca
import ErrorsPapelSegurancaHelper from "./ErrorPapelSegurancaHelper"

class ErrorsPapelSegurancaLoteHelper {
  static getError (message) {
    const messageType = typeof message
    let messageText = null

    switch (messageType) {
    case 'object':
      if (Array.isArray()) {
        messageText = ErrorsPapelSegurancaLoteHelper.isArray(message)
      } else {
        messageText = ErrorsPapelSegurancaLoteHelper.isObject(message)
      }
      break
    case 'string':
      messageText = message
      break
    }

    return messageText
  }

  static isObject (message) {
    // iremos pegar o erro de acordo com o tipo do codigo
    switch (message.code) {
      // ER_DUP_ENTRY é geralmente quando tenta salvar um indice duplicado
      // unique, primary
      case 'ER_DUP_ENTRY':
        // irá ser utilizado somente a tratativa para unique
        return ErrorsPapelSegurancaHelper.unique(message.sqlMessage)
      break
    }
  }

  static isArray (message) {
    // ainda a implementar
    console.info('Implementar tratativa de array')
  }
}

export default ErrorsPapelSegurancaLoteHelper
